// src/api/epkPublic.ts
//
// Public (unauthenticated) API functions for EPK pages.
// Uses raw fetch() — no Axios, no auth interceptors.
// This module is imported by the lightweight public app and must not
// pull in any heavy dependencies.

import type { PublicEpkData } from '@/types/epk';

const API_URL = import.meta.env.VITE_API_URL;

export async function getPublicEpk(slug: string): Promise<PublicEpkData> {
  const response = await fetch(`${API_URL}/public/epk/${slug}`);
  if (!response.ok) {
    const error = await response.json();
    throw error;
  }
  return response.json();
}

export async function logEpkEvent(
  slug: string,
  event: {
    event_type: string;
    link_id?: string;
    link_label?: string;
    referrer?: string;
    tracking_id?: string;
  },
): Promise<void> {
  await fetch(`${API_URL}/public/epk/${slug}/events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(event),
  });
}

export async function submitEpkEmailSignup(slug: string, email: string): Promise<void> {
  const response = await fetch(`${API_URL}/public/epk/${slug}/signup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (!response.ok) {
    const error = await response.json();
    throw error;
  }
}

export async function reportEpk(
  slug: string,
  reason: string,
  details?: string,
): Promise<void> {
  await fetch(`${API_URL}/public/epk/${slug}/report`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason, details }),
  });
}
